import { render, staticRenderFns } from "./DicomViewer.vue?vue&type=template&id=ae2c3480&scoped=true&"
import script from "./DicomViewer.vue?vue&type=script&lang=js&"
export * from "./DicomViewer.vue?vue&type=script&lang=js&"
import style0 from "./DicomViewer.vue?vue&type=style&index=0&id=ae2c3480&prod&scoped=true&lang=css&"
import style1 from "./DicomViewer.vue?vue&type=style&index=1&id=ae2c3480&prod&scoped=true&lang=css&"
import style2 from "./DicomViewer.vue?vue&type=style&index=2&id=ae2c3480&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2c3480",
  null
  
)

export default component.exports